import React, { PureComponent } from 'react';
import cn from 'classnames';
import { FMessage } from '../../hoc/IntlComponents';
import Select from '../common/Select';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { array, func, bool, number } from 'prop-types';
import FlowOffers from './FlowOffers';
import ApiService from '../../services/ApiService';

class FlowFailAction extends PureComponent {
  static propTypes = {
    offers: array.isRequired,
    onChangeFailAction: func.isRequired,
    availableFailActions: array,
    disabled: bool,
    theme: number,
    offerId: number,
    streamId: number,
    isAgencyStream: bool,
  };

  static defaultProps = {
    offers: [],
    availableFailActions: [],
    theme: 1,
  };

  state = {
    type: '',
    value: null,
    availableFailActionsOptions: [
      {
        value: 1,
        label: <FMessage id="flow.form.fail-action.redirect-url" />,
      },
      {
        value: 2,
        label: <FMessage id="flow.form.fail-action.redirect-offer" />,
      },
      {
        value: 3,
        label: <FMessage id="flow.form.fail-action.redirect-news" />,
      },
      { value: 4, label: <FMessage id="flow.form.fail-action.redirect-stream" /> },
      { value: 5, label: <FMessage id="flow.form.fail-action.redirect-whitepage" /> },
    ],
    selectedAsyncSelectOption: null,
  };

  componentDidMount() {
    this.getFailActionOptions();
  }

  componentDidUpdate(prevProps) {
    const previousAvailableFailActions = prevProps.availableFailActions;
    const { availableFailActions } = this.props;

    if (availableFailActions !== previousAvailableFailActions) {
      this.getFailActionOptions();
    }

    if (this.props.isAgencyStream !== prevProps.isAgencyStream && this.props.isAgencyStream) {
      this.setState({
        type: 5,
        availableFailActionsOptions: [
          { value: 5, label: <FMessage id="flow.form.fail-action.redirect-whitepage" /> },
        ],
      });
    }
  }

  getFailActionOptions = () => {
    if (this.props.availableFailActions.length > 0) {
      this.setState({
        availableFailActionsOptions: this.props.availableFailActions.map((_) => ({
          value: _.id,
          label: _.title,
        })),
      });
    }

    for (let action of this.props.availableFailActions) {
      if (action.selected) {
        this.setState(
          {
            type: action.id,
            value: action.value,
            selectedAsyncSelectOption:
              action.id === 4 ? { value: action.value, label: action.label } : null,
          },
          this.updateFailAction,
        );
      }
    }
  };

  handleValueChange = ({ value }) => {
    this.setState({ value }, this.updateFailAction);
  };

  handleAyncSelectChange = (selectedAsyncSelectOption) => {
    this.setState(
      { selectedAsyncSelectOption, value: selectedAsyncSelectOption.value },
      this.updateFailAction,
    );
  };

  handleActionChange = (actionId) => {
    // take dafault value from available actions
    const defaultValue = this.props.availableFailActions.find(
      (action) => action.id === actionId,
    )?.value;

    this.setState({ type: actionId, value: defaultValue }, this.updateFailAction);
  };

  loadRedirectFlowsOptions = (inputValue) => {
    if (!inputValue) {
      return Promise.resolve({ options: [] });
    }
    return ApiService.streams
      .getStreams({ limit: 50, short: 1, title: inputValue })
      .then((resp) => ({
        options: resp.items
          .map((_) => ({ value: _.id, label: _.title }))
          .filter((_) => _.value !== this.props.streamId),
      }));
  };

  updateFailAction() {
    const { type } = this.state;
    this.props.onChangeFailAction({ type, value: this.state.value });
  }

  render() {
    const { type, value, availableFailActionsOptions, selectedAsyncSelectOption } = this.state;
    const { offers, theme, disabled, offerId } = this.props;

    return (
      <>
        <FormGroup className={cn('form-group-upper-label', 'no-margin')}>
          <Label htmlFor="fail-action">
            <FMessage id="flow.form.fail-action.title" />
          </Label>
          <Select
            id="fail-action"
            name="fail-action"
            clearable={false}
            value={type}
            onChange={({ value }) => this.handleActionChange(value)}
            options={availableFailActionsOptions}
            searchable={false}
            disabled={disabled}
          />
        </FormGroup>

        {type === 1 && (
          <FormGroup className="no-margin">
            <Label for="fail-action-url">URL</Label>
            <Input
              id="fail-action-url"
              name="url"
              type="url"
              onChange={({ target: { value } }) => this.handleValueChange({ value })}
              value={value ?? ''}
              disabled={disabled}
              placeholder="http://example.com"
            />
          </FormGroup>
        )}

        {type === 2 && (
          <FlowOffers
            theme={this.props.theme}
            name="offer"
            className="no-margin"
            offerId={value ?? 0}
            offers={offers.filter(({ id }) => id !== offerId)}
            disabled={disabled}
            onOfferChange={this.handleValueChange}
          />
        )}

        {type === 4 && (
          <FormGroup className="no-margin">
            <Label for="fail-action-flow">
              <FMessage id="flow.form.fail-action.flow" />
            </Label>
            <Select
              id="fail-action-flow"
              name="fail-action-flow"
              clearable={false}
              value={selectedAsyncSelectOption}
              onChange={this.handleAyncSelectChange}
              searchable={true}
              asyncSearch
              loadOptions={this.loadRedirectFlowsOptions}
              disabled={disabled}
            />
          </FormGroup>
        )}
      </>
    );
  }
}

export default FlowFailAction;
